var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAShape2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 25,
    viewBox: "0 0 20 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3916 0.188485C11.0043 0.404733 11.3256 1.07673 11.1094 1.68944C10.4177 3.64926 7.43383 6.58394 1.17647 6.58394C0.526724 6.58394 0 6.05722 0 5.40747C0 4.75773 0.526724 4.231 1.17647 4.231C6.71605 4.231 8.61534 1.68624 8.8906 0.906332C9.10685 0.293627 9.77885 -0.0277643 10.3916 0.188485Z",
    fill: "#1D2433",
    fillOpacity: 0.65
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.87894 24.5874C9.23265 24.5206 8.76292 23.9424 8.82978 23.2961C9.08062 20.8713 9.83653 17.2234 11.3214 14.1432C12.7744 11.1292 15.1559 8.21976 18.8235 8.21976C19.4733 8.21976 20 8.74649 20 9.39623C20 10.046 19.4733 10.5727 18.8235 10.5727C16.5927 10.5727 14.8042 12.3369 13.4409 15.165C12.1095 17.9269 11.4029 21.2894 11.1702 23.5382C11.1034 24.1845 10.5252 24.6543 9.87894 24.5874Z",
    fill: "#1D2433",
    fillOpacity: 0.65
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.79555 0.0180986C9.15569 0.131015 8.72851 0.741261 8.84143 1.38112C9.1116 2.91205 9.91304 5.16461 11.4725 7.06091C13.0583 8.98931 15.4562 10.5723 18.8235 10.5723C19.4733 10.5723 20 10.0456 20 9.39585C20 8.7461 19.4733 8.21937 18.8235 8.21937C16.2924 8.21937 14.5203 7.06265 13.2898 5.5664C12.033 4.03804 11.3719 2.18101 11.1586 0.972214C11.0457 0.332354 10.4354 -0.0948178 9.79555 0.0180986Z",
    fill: "#1D2433",
    fillOpacity: 0.65
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0944 24.5899C10.7421 24.5377 11.2248 23.9704 11.1727 23.3228C10.9256 20.2545 10.1794 15.6357 8.72031 11.7478C7.99214 9.80756 7.05838 7.97248 5.86134 6.60308C4.65382 5.22169 3.0977 4.23108 1.17647 4.23108C0.526723 4.23108 -9.67453e-07 4.7578 -9.35763e-07 5.40755C-9.04073e-07 6.05729 0.526723 6.58402 1.17647 6.58402C2.20447 6.58402 3.16548 7.09421 4.08981 8.15163C5.02462 9.22104 5.83744 10.7628 6.5174 12.5746C7.87454 16.1907 8.59096 20.5767 8.82733 23.5117C8.87949 24.1593 9.4468 24.642 10.0944 24.5899Z",
    fill: "#1D2433",
    fillOpacity: 0.65
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAShape2);
export default __webpack_public_path__ + "static/media/a-shape2.a7c014d6c14b115881c6c872e90c03ee.svg";
export { ForwardRef as ReactComponent };